import { defineMessages } from 'react-intl';

export default defineMessages({
	loggedOutDescription: {
		id: 'profile.loggedOut.description',
		defaultMessage: 'Create an account to save your progress and see your stats',
		description: 'A subtitle on the profile page that directs the user to a login/signup button',
	},
	cta: {
		id: 'profile.loggedOut.loginButton',
		defaultMessage: 'Sign up or Log in',
		description: 'The text within a login/signup button',
	},
});
